import Image from 'next/image';
import Link from 'next/link';
import { DAVINCI_CDN } from '@/costants/defaultValues';
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { plusJakartaSansFont } from '@/styles/fonts';
import clsx from 'clsx';

export const ServiceCard: React.FC<{ link: string | undefined; service: string; location?: string; description?: string }> = ({
  link,
  service,
  location,
  description,
}) => {
  const urlParams = new URLSearchParams();

  if (location) {
    urlParams.set('location', location.toLowerCase());
  }

  urlParams.set('service', service);

  return (
    <Link
      href={link ? link : `/cerca?${urlParams.toString()}`}
      className="group flex w-full flex-grow flex-row items-center gap-2 bg-neutral-surface px-1.5 transition-colors"
      prefetch={false}
    >
      <div className="flex flex-grow flex-col gap-2">
        <div className="flex flex-row items-center gap-3">
          <Image src={`${DAVINCI_CDN}/inclinic/icons/medical-services.png`} alt="" width={24} height={24} aria-hidden />
          <span className={clsx(plusJakartaSansFont.className, 'font-medium text-neutral-darker')}>{service}</span>
        </div>

        {location && (
          <div className="flex flex-row items-center gap-3 text-sm text-neutral-lighter text-text-body">
            <Image src={`${DAVINCI_CDN}/inclinic/icons/pin.png`} width={24} height={24} alt="" />
            <span>{location}</span>
          </div>
        )}

        {description && (
          <span className={clsx(plusJakartaSansFont.className, 'text-sm font-normal text-neutral-lighter')}>{description}</span>
        )}
      </div>

      <ChevronRightIcon
        className="shrink-0 translate-x-0 text-secondary transition-transform group-hover:translate-x-2"
        width={20}
        height={20}
        color="#07142F"
        aria-hidden
      />
    </Link>
  );
};
